import React from 'react';

interface TitleSection {
  children: React.ReactNode;
}
export const TitleSection: React.FC<TitleSection> = ({ children }: TitleSection) => {
  return (
    <div className="w-full lg:w-[700px] flex flex-col justify-center items-center gap-4 lg:gap-8">
      {children}
    </div>
  );
};
